import { render, staticRenderFns } from "./CadastroImpFederal.vue?vue&type=template&id=557bf4fc&scoped=true"
import script from "./CadastroImpFederal.vue?vue&type=script&lang=js"
export * from "./CadastroImpFederal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557bf4fc",
  null
  
)

export default component.exports